import {
  type ResultOf,
  type VariablesOf,
} from '@graphql-typed-document-node/core'
import { useMutation, type UseMutationOptions } from '@tanstack/react-query'

import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'

const document = graphql(`
  mutation RecordOverallLlmEvent($input: RecordLlmEventInput!) {
    recordLlmEvent(input: $input)
  }
`)

type Variables = VariablesOf<typeof document>['input']

export const useRecordOverallLlmEventMutation = (
  options: Omit<
    UseMutationOptions<ResultOf<typeof document>, unknown, Variables, unknown>,
    'mutationFn'
  > = {},
) => {
  const graphQLRequest = useGraphQLRequest()

  return useMutation({
    mutationFn: (vars) =>
      graphQLRequest({ document, variables: { input: vars } }),
    ...options,
  })
}
